import { NOT_SELECTED_ERROR } from '../../../Stepper/constants'
import { STORE_NOT_SELECTED_ERROR } from '../../constants'

const validate = ({ catalogRefIds, selectedStore }) => {
  const errors = {}

  if (!(catalogRefIds && catalogRefIds.length)) {
    errors.catalogRefIds = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  } else if (!selectedStore) {
    errors.selectedStore = STORE_NOT_SELECTED_ERROR
    errors._error = STORE_NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
